<div
  class="fz-game-tags fz-game-tags-{{ color }} fz-game-tags-{{
    variant
  }} fz-game-tags-{{ size }}"
>
  <div *ngIf="tags && tags.length > 0" class="fz-game-tags__root">
    <!-- print first value -->
    <div *ngIf="tags.length > 0" class="fz-game-tags__tag">
      <img
        class="{{ tags[0] ? tags[0].toLowerCase().replace(' ', '_') : '' }}"
        [ngClass]="{ external: external }"
        src="{{ assetUrl }}/shared/img/tournaments/tournament_types/flat/{{
          tags[0].toLowerCase().replace(' ', '_')
        }}.svg"
        alt="Tournament tags"
      />
      <span>{{ tags[0] }}</span>
    </div>
    <div class="fz-game-tags__tag_icons">
      <span
        *ngFor="let tag of tags.slice(1).reverse()"
        class="fz-game-tags__tag_icons__icon"
      >
        <img
          [ngClass]="{ external: external }"
          src="{{ assetUrl }}/shared/img/tournaments/tournament_types/flat/{{
            tag.toLowerCase().replace(' ', '_')
          }}.svg"
          [alt]="tag"
          [matTooltip]="tag"
        />
      </span>
    </div>
  </div>
</div>
